import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import rootReducer from '@redux/modules/reducer';
import rootSaga from '@redux/modules/sagas';
import env from 'config/environment';
import { configureStoreDev } from './store.dev';

const sagaMiddleware = createSagaMiddleware();

const configureStore = () => {
  const middleware = [sagaMiddleware, thunk];

  switch (process.env.NODE_ENV) {
    case 'test':
      return createStore(rootReducer, applyMiddleware(...middleware));

    case 'production':
      return createStore(rootReducer, applyMiddleware(...middleware));

    case 'development':
      return configureStoreDev(middleware);

    default:
      return createStore(rootReducer, applyMiddleware(...middleware));
  }
};

const store = configureStore();
if (env.IsPWTest() || !env.IsProduction()) {
  // @ts-ignore
  window.store = store;
}
sagaMiddleware.run(rootSaga);

export default store;
